import React from 'react';
import { Star16Filled, Star16Regular } from '@fluentui/react-icons';
import { useRatingStarsStyles } from './RatingStars.styles';

interface RatingStarsProps {
    rating: number;
    size?: 'small' | 'medium' | 'large';
    readOnly?: boolean;
}

const RatingStars = React.forwardRef<HTMLDivElement, RatingStarsProps>(
    ({ rating, size = 'medium', readOnly = true }, ref) => {
        const styles = useRatingStarsStyles();
        const roundedRating = Math.round(rating);

        const sizeMap = {
            small: 14,
            medium: 20,
            large: 24,
        };

        const starSize = sizeMap[size];

        return (
            <div ref={ref} className={styles.container}>
                {[1, 2, 3, 4, 5].map((star) => (
                    <span key={star}>
                        {star <= roundedRating ? (
                            <Star16Filled width={starSize} height={starSize} style={{ color: '#FFB900' }} />
                        ) : (
                            <Star16Regular width={starSize} height={starSize} style={{ color: '#CCCCCC' }} />
                        )}
                    </span>
                ))}
            </div>
        );
    }
);

RatingStars.displayName = 'RatingStars';

export default RatingStars;
